import { getSearchConfig } from "../config/search-config";

const searchConfig = getSearchConfig();
export function useSearchConfig() {
  return { searchConfig };
}
